export default __webpack_public_path__ + "static/media/oksami.55adb1b4.jpg";